import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import createSelector from 'helpers/createSelector';
import moment from 'moment';
import _ from 'lodash';
import { Button, Row, Col, Icon, message, Modal, Tooltip} from 'antd';
const confirm = Modal.confirm;
import { actions } from 'modules/modal'
import Truncate from 'react-truncate-dom';
import * as notification from 'modules/notification';

import { updateQuery } from 'modules/router/actions';
import { setCollection, deleteCollection, closeLoading } from 'modules/collection/actions';
import striptags from 'striptags';

import './style.css';
const avatarUrl = require('./images/avatar.png');

class FeedItem extends Component {

  static propTypes = {
    data: PropTypes.object,
    dispatch: PropTypes.func,
  };

  state = {
    data: {},
    isLoading: false,
  };

  handleClick = (data) => {
    const {dispatch, toHtml, showTraditionalContent} = this.props;
    if ((!showTraditionalContent && _.get(data, 'isTraditional', false)) || data.mediaType == 'news') {
      dispatch(actions.setIsRead(data));
      window.open(data.url);
    } else {
      dispatch(actions.toggleArticleModal(data));
    }
  };

  replaceBr = (str) => {
    return str.replace(/<br\s*\/?>/gi,"");
  };

  handleAddCollection = (globalId) => {
    const {dispatch, collection, permission, userId} = this.props;
    if (_.get(collection, 'length', 0) < _.get(permission, 'limit')) {
      dispatch(setCollection({
        type: 'ADD',
        globalId: [globalId],
        userId: userId
      }))
      .then(() => {
        notification.showClippingSuccess();
      })
      .catch(()=>{
        dispatch(closeLoading([globalId]))
        .then(() => {
          notification.error(t('commonClippingFail'));
        })
      });
    } else {
      notification.showClippingFull();
    }
  };

  handleRemoveCollection = (globalId) => {
    const {dispatch, userId} = this.props;
    // dispatch(deleteCollection({
    //   globalId: [globalId],
    //   userId: userId,
    // }))
    dispatch(setCollection({
      type: 'DELETE',
      globalId: [globalId],
      userId: userId
    }))
  }

  renderNews(data) {
    const {dataIsRead, dispatch, collection, loadingList} = this.props;
    let images = [];
    let dataImages = _.get(data, 'images');
    // http://www.baby-kingdom.com/static/image/common/android_v1.gif?v=317
    _.map(dataImages, (img) => {
      const imgs = img.split('/')[6];
      let version = '';
      if (imgs !== undefined) {
        version = imgs.split('_')[0];
      }
      const versions = ['iphone', 'android'];
      if (!_.includes(versions, version)) {
        images = [...images, img];
      }
    })
    const len = images ? images.length : 0;
    let mediaType;
    switch(data.mediaType) {
      case 'blog':
        mediaType = t('commonBlog');
        break;
      case 'video':
        mediaType = t('commonVideo');
        break;
      case 'macautalk':
        mediaType = t('commonMacauTalk');
        break;
      case 'news':
        mediaType = t('commonNews');
        break;
      case 'forum':
        mediaType = t('commonForum');
        break;
    }
    const id = data.globalId;
    const disabled = _.includes(collection, id)
    return (
      <div>
      {len >= 1 &&
        <div className={classnames('feed', {'read' : _.includes(dataIsRead, data.globalId)})}>
          <Row>
            <Col span='16'>
              <div>
                <a
                  title={data.title}
                  onClick={() => this.handleClick(data)}
                  className={classnames({'readText' : _.includes(dataIsRead, data.globalId)})}
                >
                  <Truncate
                    className="feed-title"
                    html={data.title}
                  />
                </a>
              </div>
              <div className={classnames("feed-description",{'readText' : _.includes(dataIsRead, data.globalId)})}>
                <Truncate
                  line={1}
                  html={data.content}
                />
              </div>
              <div className="clearfix margin-top-md feed-source">
                <span className={`pull-left feed-tag feed-tag-${data.mediaType} margin-right-md`}>{t(data.mediaType)}</span>
                <span className="pull-left">
                  <span>{t('subjectMonitoringFeedFrom')} </span>
                  <a onClick={() => {dispatch(updateQuery({from: data.from}))}}>
                    {data.from}
                  </a>
                  <span> - </span>
                  <a onClick={() => {dispatch(updateQuery({from: data.from, in: data.in}))}}>
                    {data.in}
                  </a>
                  <span> {t('subjectMonitoringFeedAt')} </span>
                  <span>
                    {moment(data.date).format('YYYY-MM-DD HH:mm')}
                  </span>
                </span>
                {data.mediaType === 'forum' &&
                  <span className="pull-right">
                    <span title={t('commonHits')} className="margin-right-md">
                      <Icon type="eye-o" className="margin-right-md" />
                      {data.hits}
                    </span>
                    <span title={t('commonComments')} className="margin-right-md">
                      <Icon type="message" className="margin-right-md" />
                      {data.comments}
                    </span>
                  </span>
                }
              </div>
            </Col>
            <Col span="1"></Col>
            <Col span='5'>
              <div className="image-holder">
                <img src={images[0]} />
              </div>
            </Col>
            <Col span="2" className="clearfix">
              <div className="star-icon">
                {disabled &&
                  <Tooltip placement="bottom" title="取消收藏">
                    <Icon type="star" className="cursor-pointer star-active" onClick={() => this.handleRemoveCollection(data.globalId)}/>
                  </Tooltip>
                ||
                <span>
                  {_.includes(loadingList, data.globalId) &&
                    <Tooltip placement="top" title="收藏中...">
                      <Icon type="loading" />
                    </Tooltip>
                    ||
                    <Tooltip placement="bottom" title="加入收藏夾">
                    <Icon type="star" className="cursor-pointer" onClick={() => this.handleAddCollection(data.globalId)}/>
                    </Tooltip>
                  }
                </span>
                }
              </div>
            </Col>
          </Row>
        </div>
      ||
        <div className={classnames('feed', {'read' : _.includes(dataIsRead, data.globalId)})}>
          <Row>
            <Col span="22">
              <div>
                <a
                  title={data.title}
                  onClick={() => this.handleClick(data)}
                  className={classnames({'readText' : _.includes(dataIsRead, data.globalId)})}
                >
                  <Truncate
                    className="feed-title"
                    html={data.title}
                  />
                </a>
              </div>
              <div className={classnames("feed-description",{'readText' : _.includes(dataIsRead, data.globalId)})}>
                <Truncate
                  line={1}
                  html={data.content}
                />
              </div>
              <div className="clearfix margin-top-md feed-source">
                <span className={`pull-left feed-tag feed-tag-${data.mediaType} margin-right-md`}>{t(data.mediaType)}</span>
                <span className="pull-left">
                  <span>{t('subjectMonitoringFeedFrom')} </span>
                  <a onClick={() => {dispatch(updateQuery({from: data.from}))}}>
                    {data.from}
                  </a>
                  <span> - </span>
                  <a onClick={() => {dispatch(updateQuery({from: data.from, in: data.in}))}}>
                    {data.in}
                  </a>
                  <span> {t('subjectMonitoringFeedAt')} </span>
                  <span>
                    {moment(data.date).format('YYYY-MM-DD HH:mm')}
                  </span>
                </span>
                {data.mediaType === 'forum' &&
                  <span className="pull-right">
                    <span title={t('commonHits')} className="margin-right-md">
                      <Icon type="eye-o" className="margin-right-md" />
                      {data.hits}
                    </span>
                    <span title={t('commonComments')} className="margin-right-md">
                      <Icon type="message" className="margin-right-md" />
                      {data.comments}
                    </span>
                  </span>
                }
              </div>
            </Col>
            <Col span="2" className="clearfix">
            <div className="star-icon">
                {disabled &&
                  <Tooltip placement="bottom" title="取消收藏">
                  <Icon type="star" className="cursor-pointer star-active" onClick={() => this.handleRemoveCollection(data.globalId)}/>
                  </Tooltip>
                ||
                  <span>
                  {_.includes(loadingList, data.globalId) &&
                    <Tooltip placement="top" title="收藏中...">
                      <Icon type="loading" />
                    </Tooltip>
                    ||
                    <Tooltip placement="bottom" title="加入收藏夾">
                    <Icon type="star" className="cursor-pointer" onClick={() => this.handleAddCollection(data.globalId)}/>
                    </Tooltip>
                  }
                </span>
                }
              </div>
            </Col>
          </Row>
        </div>
      }
      </div>
    )
  }

  renderFacebook(data) {
    const {dataIsRead, dispatch, collection, loadingList} = this.props;
    const id = data.globalId;
    const disabled = _.includes(collection, id)
    return (
      <Row className={classnames('feed', {'read' : _.includes(dataIsRead, data.globalId)})}>
        <Col span="2">
          <div className="avatar">
            <img
              src={`https://graph.facebook.com/${_.get(data, 'fromId')}/picture`}
              ref={(avatar) => {
                if (avatar) {
                  avatar.onerror = () => {
                    avatar.src = avatarUrl;
                  }
                }
              }}
            />
          </div>
        </Col>
        <Col span="22">
          <Row>
            <Col span="22">
              <a
                title={data.content}
                onClick={() => this.handleClick(data)}
                className={classnames({'readText' : _.includes(dataIsRead, data.globalId)})}>
                <Truncate
                  className="feed-content"
                  line={1}
                  html={data.content}
                />
              </a>
            </Col>
            <Col span="2" className="clearfix">
            <div className="star-icon">
                {disabled &&
                  <Tooltip placement="bottom" title="取消收藏">
                  <Icon type="star" className="cursor-pointer star-active" onClick={() => this.handleRemoveCollection(data.globalId)}/>
                  </Tooltip>
                ||
                  <span>
                  {_.includes(loadingList, data.globalId) &&
                    <Tooltip placement="top" title="收藏中...">
                      <Icon type="loading" />
                    </Tooltip>
                    ||
                    <Tooltip placement="bottom" title="加入收藏夾">
                    <Icon type="star" className="cursor-pointer" onClick={() => this.handleAddCollection(data.globalId)}/>
                    </Tooltip>
                  }
                </span>
                }
              </div>
            </Col>
          </Row>
          <div className="clearfix margin-top-md feed-source">
            <span className={`pull-left feed-tag feed-tag-${data.mediaType} margin-right-md`}>{t(data.mediaType)}</span>
            <span className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <a onClick={() => {dispatch(updateQuery({by: data.by}))}}>{data.by}</a>
              <span> @ </span>
              <a onClick={() => {dispatch(updateQuery({from: data.from}))}}>{data.from}</a>
              <span> {t('subjectMonitoringFeedAt')} </span>
              <span>
                {moment(data.date).format('YYYY-MM-DD HH:mm')}
              </span>
            </span>
            <span className="pull-right">
              <span title={t('commonComments')} className="margin-right-md">
                <Icon type="message" className="margin-right-md" />
                {data.comments}
              </span>
              <span title={t('commonLikes')} className="margin-right-md">
                <Icon type="like" className="margin-right-md" />
                {data.likes}
              </span>
              <span title={t('commonShares')} className="margin-right-md">
                <Icon type="share-alt" className="margin-right-md" />
                {data.shares}
              </span>
            </span>
          </div>
        </Col>
      </Row>
    )
  }

  renderWeibo(data) {
    const {dataIsRead, dispatch, collection, loadingList} = this.props;
    const id = data.globalId;
    const disabled = _.includes(collection, id)
    return (
      <Row className={classnames('feed', {'read' : _.includes(dataIsRead, data.globalId)})}>
        <Col span="24">
          <Row>
            <Col span="23">
              <a
                title={data.content}
                onClick={() => this.handleClick(data)}
                className={classnames({'readText' : _.includes(dataIsRead, data.globalId)})}>
                <Truncate
                  className="feed-content"
                  line={1}
                  html={data.content}
                />
              </a>
            </Col>
            <Col span="1" className="clearfix">
            <div className="star-icon">
                {disabled &&
                  <Tooltip placement="bottom" title="取消收藏">
                  <Icon type="star" className="cursor-pointer star-active" onClick={() => this.handleRemoveCollection(data.globalId)}/>
                  </Tooltip>
                ||
                  <span>
                  {_.includes(loadingList, data.globalId) &&
                    <Tooltip placement="top" title="收藏中...">
                      <Icon type="loading" />
                    </Tooltip>
                    ||
                    <Tooltip placement="bottom" title="加入收藏夾">
                    <Icon type="star" className="cursor-pointer" onClick={() => this.handleAddCollection(data.globalId)}/>
                    </Tooltip>
                  }
                </span>
                }
              </div>
            </Col>
          </Row>
          <div className="clearfix margin-top-md feed-source">
            <span className={`pull-left feed-tag feed-tag-${data.mediaType} margin-right-md`}>{t(data.mediaType)}</span>
            <span className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <a onClick={() => {dispatch(updateQuery({from: data.from}))}}>{data.from}</a>
              <span> {t('subjectMonitoringFeedAt')} </span>
              <span>
                {moment(data.date).format('YYYY-MM-DD HH:mm')}
              </span>
            </span>
            <span className="pull-right">
              <span title={t('commonComments')} className="margin-right-md">
                <Icon type="message" className="margin-right-md" />
                {data.comments}
              </span>
              <span title={t('commonLikes')} className="margin-right-md">
                <Icon type="like" className="margin-right-md" />
                {data.likes}
              </span>
              <span title={t('commonShares')} className="margin-right-md">
                <Icon type="share-alt" className="margin-right-md" />
                {data.shares}
              </span>
            </span>
          </div>
        </Col>
      </Row>
    )
  }

  renderPixnet(data) {
    const {dataIsRead, dispatch, collection, loadingList} = this.props;
    const id = data.globalId;
    const disabled = _.includes(collection, id)
    return (
      <Row className={classnames('feed', {'read' : _.includes(dataIsRead, data.globalId)})}>
        <Col span="24">
          <Row>
            <Col span="23">
              <a
                title={data.title}
                onClick={() => this.handleClick(data)}
                className={classnames({'readText' : _.includes(dataIsRead, data.globalId)})}
              >
                <Truncate
                  className="feed-title"
                  html={data.title}
                />
              </a>
              <div className={classnames("feed-description",{'readText' : _.includes(dataIsRead, data.globalId)})}>
                <Truncate
                  line={1}
                  html={data.content}
                />
              </div>
            </Col>
            <Col span="1" className="clearfix">
            <div className="star-icon">
                {disabled &&
                  <Tooltip placement="bottom" title="取消收藏">
                  <Icon type="star" className="cursor-pointer star-active" onClick={() => this.handleRemoveCollection(data.globalId)}/>
                  </Tooltip>
                ||
                  <span>
                  {_.includes(loadingList, data.globalId) &&
                    <Tooltip placement="top" title="收藏中...">
                      <Icon type="loading" />
                    </Tooltip>
                    ||
                    <Tooltip placement="bottom" title="加入收藏夾">
                    <Icon type="star" className="cursor-pointer" onClick={() => this.handleAddCollection(data.globalId)}/>
                    </Tooltip>
                  }
                </span>
                }
              </div>
            </Col>
          </Row>
          <div className="clearfix margin-top-md feed-source">
            <span className={`pull-left feed-tag feed-tag-${data.mediaType} margin-right-md`}>{t(data.mediaType)}</span>
            <span className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <a onClick={() => {dispatch(updateQuery({from: data.from}))}}>{data.from}</a>
              <span> - </span>
              <a onClick={() => {dispatch(updateQuery({from: data.from, in: data.in}))}}>{data.in}</a>
              <span> - </span>
              <a onClick={() => {dispatch(updateQuery({from: data.from, in: data.in, by: data.by}))}}>{data.by}</a>
              <span> {t('subjectMonitoringFeedAt')} </span>
              <span>
                {moment(data.date).format('YYYY-MM-DD HH:mm')}
              </span>
            </span>
            <span className="pull-right">
              <span title={t('commonComments')} className="margin-right-md">
                <Icon type="eye-o" className="margin-right-md" />
                {data.comments}
              </span>
              <span title={t('commonHits')} className="margin-right-md">
                <Icon type="like" className="margin-right-md" />
                {data.hits}
              </span>
            </span>
          </div>
        </Col>
      </Row>
    )
  }

  renderYoutube(data) {
    const {dataIsRead, dispatch, collection, loadingList} = this.props;
    const id = data.globalId;
    const disabled = _.includes(collection, id)
    return (
      <Row className={classnames('feed', {'read' : _.includes(dataIsRead, data.globalId)})}>
        <Col span="24">
          <Row>
            <Col span="23">
              <a
                title={data.title}
                onClick={() => this.handleClick(data)}
                className={classnames({'readText' : _.includes(dataIsRead, data.globalId)})}
              >
                <Truncate
                  className="feed-title"
                  html={data.title}
                />
              </a>
              <div className={classnames("feed-description",{'readText' : _.includes(dataIsRead, data.globalId)})}>
                <Truncate
                  line={1}
                  html={data.content}
                />
              </div>
            </Col>
            <Col span="1" className="clearfix">
            <div className="star-icon">
                {disabled &&
                  <Tooltip placement="bottom" title="取消收藏">
                  <Icon type="star" className="cursor-pointer star-active" onClick={() => this.handleRemoveCollection(data.globalId)}/>
                  </Tooltip>
                ||
                  <span>
                  {_.includes(loadingList, data.globalId) &&
                    <Tooltip placement="top" title="收藏中...">
                      <Icon type="loading" />
                    </Tooltip>
                    ||
                    <Tooltip placement="bottom" title="加入收藏夾">
                    <Icon type="star" className="cursor-pointer" onClick={() => this.handleAddCollection(data.globalId)}/>
                    </Tooltip>
                  }
                </span>
                }
              </div>
            </Col>
          </Row>
          <div className="clearfix margin-top-md feed-source">
            <span className={`pull-left feed-tag feed-tag-${data.mediaType} margin-right-md`}>{t(data.mediaType)}</span>
            <span className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <a onClick={() => {dispatch(updateQuery({from: data.from}))}}>{data.from}</a>
              <span> - </span>
              <a onClick={() => {dispatch(updateQuery({from: data.from, in: data.in, by: data.by}))}}>{data.by}</a>
              <span> {t('subjectMonitoringFeedAt')} </span>
              <span>
                {moment(data.date).format('YYYY-MM-DD HH:mm')}
              </span>
            </span>
            <span className="pull-right">
              <span title={t('commonHits')} className="margin-right-md">
                <Icon type="eye-o" className="margin-right-md" />
                {data.hits}
              </span>
              <span title={t('commonComments')} className="margin-right-md">
                <Icon type="eye-o" className="margin-right-md" />
                {data.comments}
              </span>
              <span title={t('commonLikes')} className="margin-right-md">
                <Icon type="like" className="margin-right-md" />
                {data.likes}
              </span>
            </span>
          </div>
        </Col>
      </Row>
    )
  }

  renderWechat(data) {
    const {dataIsRead, dispatch, collection, loadingList} = this.props;
    const id = data.globalId;
    const disabled = _.includes(collection, id)
    return (
      <Row className={classnames('feed', {'read' : _.includes(dataIsRead, data.globalId)})}>
        <Col span="16">
          <div>
            <a
              title={data.title}
              onClick={() => this.handleClick(data)}
              className={classnames({'readText' : _.includes(dataIsRead, data.globalId)})}>
              <Truncate
                className="feed-title"
                html={data.title}
              />
            </a>
          </div>
          <div className={classnames("feed-description",{'readText' : _.includes(dataIsRead, data.globalId)})}>
            <Truncate
              line={1}
              html={data.content}
            />
          </div>
          <div className="margin-top-md clearfix feed-source">
            <span className={`pull-left feed-tag feed-tag-${data.mediaType} margin-right-md`}>{t('commonWechat')}</span>
            <span className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <a onClick={() => {dispatch(updateQuery({from: data.from}))}}>
                {data.from}
              </a>
              <span> {t('subjectMonitoringFeedAt')} </span>
              <span>
                {moment(data.date).format('YYYY-MM-DD HH:mm')}
              </span>
            </span>
            <span className="pull-right">
              <span title={t('commonHits')} className="margin-right-md">
                <Icon type="eye-o" className="margin-right-md" />
                {data.hits}
              </span>
              <span title={t('commonLikes')} className="margin-right-md">
                <Icon type="like" className="margin-right-md" />
                {data.likes}
              </span>
            </span>
          </div>
        </Col>
        <Col span="1" />
        <Col span="5">
          <div className="image-holder">
            <img src={_.get(data, 'images[0]')} />
          </div>
        </Col>
        <Col span="2" className="clearfix">
        <div className="star-icon">
                {disabled &&
                  <Tooltip placement="bottom" title="取消收藏">
                  <Icon type="star" className="cursor-pointer star-active" onClick={() => this.handleRemoveCollection(data.globalId)}/>
                  </Tooltip>
                ||
                  <span>
                  {_.includes(loadingList, data.globalId) &&
                    <Tooltip placement="top" title="收藏中...">
                      <Icon type="loading" />
                    </Tooltip>
                    ||
                    <Tooltip placement="bottom" title="加入收藏夾">
                    <Icon type="star" className="cursor-pointer" onClick={() => this.handleAddCollection(data.globalId)}/>
                    </Tooltip>
                  }
                </span>
                }
              </div>
        </Col>
      </Row>
    )
  }

  renderTwitter(data) {
    const {dataIsRead, dispatch, collection, loadingList} = this.props;
    const id = data.globalId;
    const disabled = _.includes(collection, id)
    return (
      <Row className={classnames('feed', {'read' : _.includes(dataIsRead, data.globalId) })}>
        <Col span="2">
          <div className="avatar">
            <img
              src={data.byImageUrl}
              ref={(avatar) => {
                if (avatar) {
                  avatar.onerror = () => {
                    avatar.src = avatarUrl;
                  }
                }
              }}
              />
          </div>
        </Col>
        <Col span="22">
          <Row>
            <Col span="22">
              <div>
                <a
                  title={data.content}
                  onClick={() => this.handleClick(data)}
                  className={classnames({'readText' : _.includes(dataIsRead, data.globalId)})}>
                  <Truncate
                    line={1}
                    className="feed-content"
                    html={data.content}
                  />
                </a>
              </div>
            </Col>
            <Col span="2" className="clearfix">
            <div className="star-icon">
                {disabled &&
                  <Tooltip placement="bottom" title="取消收藏">
                  <Icon type="star" className="cursor-pointer star-active" onClick={() => this.handleRemoveCollection(data.globalId)}/>
                  </Tooltip>
                ||
                  <span>
                  {_.includes(loadingList, data.globalId) &&
                    <Tooltip placement="top" title="收藏中...">
                      <Icon type="loading" />
                    </Tooltip>
                    ||
                    <Tooltip placement="bottom" title="加入收藏夾">
                    <Icon type="star" className="cursor-pointer" onClick={() => this.handleAddCollection(data.globalId)}/>
                    </Tooltip>
                  }
                </span>
                }
              </div>
            </Col>
          </Row>
          <div className="clearfix margin-top-md feed-source">
            <span className={`pull-left feed-tag feed-tag-${data.mediaType} margin-right-md`}>Twitter</span>
            <span className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <a onClick={() => {dispatch(updateQuery({in: data.in, by: data.by}))}}>{data.by}</a>
              {data.in && <span> @ </span>}
              <a onClick={() => {dispatch(updateQuery({in: data.in}))}}>{data.in}</a>
              <span> {t('subjectMonitoringFeedAt')} </span>
              <span>
                {moment(data.date).format('YYYY-MM-DD HH:mm')}
              </span>
            </span>
            <span className="pull-right">
              <span title={t('commonComments')} className="margin-right-md">
                <Icon type="message" className="margin-right-md" />
                {data.shares}
              </span>
              <span title={t('commonLikes')} className="margin-right-md">
                <Icon type="like" className="margin-right-md" />
                {data.likes}
              </span>
            </span>
          </div>

        </Col>
      </Row>
    )
  }

  renderInstagram(data) {
    const {dataIsRead, dispatch, collection, loadingList} = this.props;
    const id = data.globalId;
    const disabled = _.includes(collection, id)
    const len = _.get(data, 'images') ? _.get(data, 'images.length') : 0;
    return (
      <Row className={classnames('feed', {'read' : _.includes(dataIsRead, data.globalId)})}>
        <Col span="24">
          <Row>
            {len >= 1 &&
              <Col span="5">
                <div className="image-holder padding-right-md">
                  <img src={_.get(data, 'images[0]')}/>
                </div>
              </Col>
            }
            <Col span={len >= 1 ? '17': '22'}>
              <a
                title={data.content}
                onClick={() => this.handleClick(data)}
                className={classnames({'readText' : _.includes(dataIsRead, data.globalId)})}>
                <Truncate
                  className="feed-content"
                  line={3}
                  html={data.content}
                />
              </a>
            </Col>
            <Col span="2" className="clearfix">
              <div className="star-icon">
                {disabled &&
                  <Tooltip placement="bottom" title="取消收藏">
                  <Icon type="star" className="cursor-pointer star-active" onClick={() => this.handleRemoveCollection(data.globalId)}/>
                  </Tooltip>
                ||
                  <span>
                  {_.includes(loadingList, data.globalId) &&
                    <Tooltip placement="top" title="收藏中...">
                      <Icon type="loading" />
                    </Tooltip>
                    ||
                    <Tooltip placement="bottom" title="加入收藏夾">
                    <Icon type="star" className="cursor-pointer" onClick={() => this.handleAddCollection(data.globalId)}/>
                    </Tooltip>
                  }
                </span>
                }
              </div>
            </Col>
          </Row>
          <div className="clearfix margin-top-md feed-source">
            <span className={`pull-left feed-tag feed-tag-${data.mediaType} margin-right-md`}>Instagram</span>
            <span className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <a onClick={() => {dispatch(updateQuery({from: data.from}))}}>{data.from}</a>
              <span> {t('subjectMonitoringFeedAt')} </span>
              <span>
                {moment(data.date).format('YYYY-MM-DD HH:mm')}
              </span>
            </span>
            <span className="pull-right">
              <span title={t('commonComments')} className="margin-right-md">
                <Icon type="message" className="margin-right-md" />
                {data.comments}
              </span>
              <span title={t('commonLikes')} className="margin-right-md">
                <Icon type="like" className="margin-right-md" />
                {data.likes}
              </span>
            </span>
          </div>
        </Col>
      </Row>
    )
  }

  renderItem(data) {
    switch(data.mediaType) {
      case 'news':
      case 'forumComment':
      case 'forum':
      case 'blog':
      case 'video':
      case 'macautalk':
        return this.renderNews(data);
        break;
      case 'pixnet':
        return this.renderPixnet(data);
        break;
      case 'youtube':
        return this.renderYoutube(data);
        break;
      case 'weibo':
        return this.renderWeibo(data);
        break;
      case 'facebook':
        return this.renderFacebook(data);
        break;
      case 'wechat':
        return this.renderWechat(data);
        break;
      case 'twitter':
        return this.renderTwitter(data);
        break;
      case 'instagram':
        return this.renderInstagram(data);
        break;
      default:
        return this.renderNews(data);
        break;
    }
  }

  render() {
    const {data} = this.props;
    return (
      <div>
        <div>{this.renderItem(data)}</div>
      </div>
    );
  }
}

const container = connect(
  createSelector(
    (state) => ({
      dataIsRead: _.get(state, 'modal.dataIsRead'),
      collection: _.get(state, 'collection.globalIds'),
      permission: _.get(state, 'me.permission.favoriteQuota'),
      me: _.get(state, 'me'),
      toHtml: _.get(state, 'sourceGroup.toHtml'),
      loadingList: _.get(state, 'collection.loadingList'),
    })
    ,
    (state) => {
      const {permission, loadingList, toHtml} = state;
      const showTraditionalContent = _.get(state, 'me.permission.showTraditionalContent', false);
      return {
        dataIsRead: state.dataIsRead,
        collection: state.collection,
        permission: permission,
        userId: _.get(state, 'me.id'),
        loadingList,
        toHtml,
        showTraditionalContent
      }
    }
  )
);

export default container(FeedItem);



/** WEBPACK FOOTER **
 ** ./src/app/modules/feed/components/FeedItem.js
 **/